import Plyr from 'plyr';
import {x, x0} from '../_helpers';

export default class Video {
    constructor() {
        this.init();
    }

    init() {
        const player = new Plyr('#player', {
            controls: []
        })

        x0('[js-video-trigger]').addEventListener('click', () => {
            player.togglePlay()
        })
    }
}